import {
	buildQueryString,
	getRoutePath
} from '@sporkbytes/routing';

const entityPathSegment = "contacts";
function changePersonalProfileUrl(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "personal-profile-url"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function sendPersonalProfile(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "personal-profile", "send"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function getAll(axios, queryStringConfig) {
	const config = {
		entityPathSegment,
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function get(axios, id, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function post(axios, body) {
	const config = {
		entityPathSegment
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function put(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function addExistingPartnerLocation(axios, id, PartnerLocationId, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "partner-locations", PartnerLocationId]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function removePartnerLocation(axios, id, PartnerLocationId, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "partner-locations", PartnerLocationId],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.delete(routePath)
		.then(response => response.data);
}
function setPartnerLocations(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "partner-locations"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function addExistingMealProposal(axios, id, MealProposalId, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "meal-proposals", MealProposalId]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function addNewMealProposal(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "meal-proposals"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function getMealProposals(axios, id, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "meal-proposals"],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function removeMealProposal(axios, id, MealProposalId, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "meal-proposals", MealProposalId],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.delete(routePath)
		.then(response => response.data);
}
function setMealProposals(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "meal-proposals"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function addExistingPurchaseOrder(axios, id, PurchaseOrderId, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "purchase-orders", PurchaseOrderId]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function addNewPurchaseOrder(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "purchase-orders"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function getPurchaseOrders(axios, id, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "purchase-orders"],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function removePurchaseOrder(axios, id, PurchaseOrderId, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "purchase-orders", PurchaseOrderId],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.delete(routePath)
		.then(response => response.data);
}
function setPurchaseOrders(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "purchase-orders"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
export {
	addExistingMealProposal,
	addExistingPartnerLocation,
	addExistingPurchaseOrder,
	addNewMealProposal,
	addNewPurchaseOrder,
	changePersonalProfileUrl,
	get,
	getAll,
	getMealProposals,
	getPurchaseOrders,
	post,
	put,
	removeMealProposal,
	removePartnerLocation,
	removePurchaseOrder,
	sendPersonalProfile,
	setMealProposals,
	setPartnerLocations,
	setPurchaseOrders
};
